import { useQueryClient } from "@tanstack/react-query";
import { hsmApi } from "../../api";
import { RequireSignStatus } from "../../types";

/**
 * Hook trả về hàm polling imperative, có thể await trực tiếp trong async function.
 * Dùng queryClient.fetchQuery để gọi API, polling mỗi 2s cho đến khi status khác 1 (Đang ký).
 *
 * Cách dùng:
 * const { pollRequireSign } = useCheckRequireSignPolling();
 * const status = await pollRequireSign(requireSignId); // 2: Đã ký, 3: Lỗi
 */
export const useCheckRequireSignPolling = () => {
  const queryClient = useQueryClient();
  const pollRequireSign = async (requireSignId: string, signal?: AbortSignal): Promise<RequireSignStatus | null> => {
    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    // eslint-disable-next-line no-constant-condition
    while (true) {
      if (signal?.aborted) {
        return null;
      }

      const result = await queryClient.fetchQuery({
        queryKey: ["check-require-sign-detail-polling", requireSignId],
        queryFn: () => hsmApi.checkRequireSignStatus({ requireSignId }, { signal } as any),
        cacheTime: 0,
      });

      // 1: Đang ký → tiếp tục polling, 2: Đã ký, 3: Lỗi → trả về
      if (result.Data && result.Data !== 1) {
        return result.Data;
      }

      await delay(5000);
    }
  };

  return { pollRequireSign };
};
